import React, { useRef } from "react";
import API_BASE_URL from "../Config.js";

function PasswordModal({ user, isOpen, onClose }) {
  const currentPasswordRef = useRef(null);
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);

  if (!isOpen) return null; // 모달이 닫혀있으면 아무것도 렌더링하지 않음

  const handlePasswordChange = async () => {
    const currentPassword = currentPasswordRef.current.value;
    const newPassword = newPasswordRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;

    if (newPassword !== confirmPassword) {
      alert("새 비밀번호와 재입력 비밀번호가 일치하지 않습니다.");
      return;
    }

    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/chgpasswd`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          userId: user.login_id,
          currentPassword,
          newPassword
        })
      });

      if (response.ok) {
        alert("비밀번호가 성공적으로 변경되었습니다.");
        onClose();
        //window.location.reload(); // 성공 시만 클린 리프레시
      } else {
        alert("비밀번호 변경 실패. 기존 비밀번호를 확인하세요.");
      }
    } catch (err) {
      alert("서버 오류: " + err.message);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>비밀번호 변경</h3>
        <input type="text" placeholder="기존 비밀번호" ref={currentPasswordRef} />
        <input type="text" placeholder="새 비밀번호" ref={newPasswordRef} />
        <input type="text" placeholder="새 비밀번호 재입력" ref={confirmPasswordRef} />
        
        <div className="modal-actions">
          <button className="action-btn save" onClick={handlePasswordChange}>확인</button>
          <button className="action-btn cancel" onClick={onClose}>취소</button>
        </div>
      </div>
    </div>
  );
}

export default PasswordModal;
